export default __webpack_public_path__ + "static/media/equalizer.1b6a067d.png";